import React from "react";
import CG_FooterButtons from "./CG_FooterButtons";
import CG_Header from "./CG_Header";
import Page1 from "../../assets/images/seller_page-0001.png";
import Page2 from "../../assets/images/seller_page-0002.png";
import Page3 from "../../assets/images/seller_page-0003.png";
import Page4 from "../../assets/images/seller_page-0004.png";
import { useNavigate } from "react-router-dom";

export default function CG_FinalReview() {
    const navigate = useNavigate();
    return (
        <div className="tw-h-[calc(90vh)] tw-overflow-hidden">
            <CG_Header screen="preview-contract" />
            <div className="tw-p-10 tw-px-[5%] tw-text-[#001659]">
                <h1 className="tw-underline tw-text-center tw-font-[700] tw-text-[30px] tw-text-[#001659]">Preview your contract</h1>
                <div className="tw-w-full tw-mt-5">
                    <div className="tw-flex tw-gap-10 ">
                        <div className="tw-w-1/2 tw-h-[calc(70vh)] tw-overflow-auto tw-flex tw-flex-col tw-gap-5">
                            <div className="tw-w-full">
                                <p className="tw-font-[800]">Basic Information</p>
                                <div className="tw-bg-[#F1F1F1] tw-p-3 tw-rounded-md tw-flex-col tw-flex tw-gap-2">
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Name:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Contact:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Email:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Nationality:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                </div>
                            </div>
                            <div className="tw-w-full">
                                <p className="tw-font-[800]">Property Details:</p>
                                <div className="tw-bg-[#F1F1F1] tw-p-3 tw-rounded-md tw-flex-col tw-flex tw-gap-2">
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Name:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Contact:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Email:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Nationality:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                </div>
                            </div>
                            <div className="tw-w-full">
                                <p className="tw-font-[800]">Offer Details:</p>
                                <div className="tw-bg-[#F1F1F1] tw-p-3 tw-rounded-md tw-flex-col tw-flex tw-gap-2">
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Name:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Contact:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Email:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Nationality:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                </div>
                            </div>
                            <div className="tw-w-full">
                                <p className="tw-font-[800]">Financing Information:</p>
                                <div className="tw-bg-[#F1F1F1] tw-p-3 tw-rounded-md tw-flex-col tw-flex tw-gap-2">
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Name:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Contact:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Email:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Nationality:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                </div>
                            </div>
                            <div className="tw-w-full">
                                <p className="tw-font-[800]">Additional terms & Conditions:</p>
                                <div className="tw-bg-[#F1F1F1] tw-p-3 tw-rounded-md tw-flex-col tw-flex tw-gap-2">
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Name:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Contact:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Email:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Nationality:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tw-w-1/2 tw-h-[calc(70vh)] tw-overflow-auto">
                            <img src={Page1} className="tw-w-full tw-h-auto" alt="page 1" />
                            <img src={Page2} className="tw-w-full tw-h-auto" alt="page 1" />
                            <img src={Page3} className="tw-w-full tw-h-auto" alt="page 1" />
                            <img src={Page4} className="tw-w-full tw-h-auto" alt="page 1" />
                        </div>
                    </div>
                </div>
            </div>
            <CG_FooterButtons navigate={navigate} screen={"final-preview"} />
        </div>
    );
}
